module.exports = __webpack_public_path__ + "static/media/S1.46e93ec4.png";